import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { retry, catchError } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { SettingService } from './setting.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  constructor(private http: HttpClient, private settingsService: SettingService) { }
  params = { idSession: '', nombre: '', app: '', usuarioWeb: '', bloqueos: '' };
  url = this.settingsService.settings.usuario;
  ipiFy = this.settingsService.settings.ipFyService;
  pocaeHitorial = this.settingsService.settings.pocaeHistorial;
  error: any;

  private session = new BehaviorSubject(this.params);
  currentSession = this.session.asObservable();

  publicIp() {
    return this.http.get(this.ipiFy);
  }

  addSession(idSession: string, nombre: string, hostName: string, usuarioWeb: string, bloqueos: any) {
    this.params = { idSession: idSession, nombre: nombre, app: hostName, usuarioWeb: usuarioWeb, bloqueos: bloqueos };
    this.session.next(this.params)
  }

  iniciar(json) {
    return this.http.post(this.url + '/usuario/sesion/creaSesion', JSON.stringify(json))
      .pipe(retry(4), catchError(this.error))
  }

  recuperar(json) {
    return this.http.post(this.url + "/usuario/recuperaPassword", JSON.stringify(json))
      .pipe(retry(4), catchError(this.error));
  }
  resetPass(json) {
    return this.http.post(this.url + "/usuario/reiniciaPassword", JSON.stringify(json))
      .pipe(retry(4), catchError(this.error))
  }

  crear(json) {
    return this.http.post(this.url, JSON.stringify(json))
      .pipe(retry(4), catchError(this.error));
  }

  validaCorreo(json) {
    return this.http.post(this.url + "/usuario/verificaIndValido", JSON.stringify(json))
      .pipe(retry(4), catchError(this.error))
  }

  actualizaIndValido(json) {
    return this.http.post(this.url + "/usuario/actualizaIndValido", JSON.stringify(json))
      .pipe(retry(4), catchError(this.error))
  }
}
